import request from '../../axios/axiosconfig.js'

export function csCapitalDetail(params) {
  return request({
    url: '/ps/csCapitalDetail/csCapitalDetail',
    method: 'get',
    params: params
  })
}
export function operationAccount(data) {
  return request({
    url: '/ps/csRelation/operationAccount',
    method: 'post',
    data: data
  })
}
export function getFrozen(params) {
  return request({
    url: '/ps/csCapitalDetail/getFrozen/'+params,
    method: 'get'
  })
}
export function thawBalance(data) {
  return request({
    url: '/ps/csCapitalDetail/thawBalance',
    method: 'post',
    data: data
  })
}
export function getWithdrawByCsId(page,csId) {
  return request({
    url: '/ps/csCapitalDetail/getWithdrawByCsId/'+csId,
    method: 'get',
    params: page
  })
}

export function frozenBalance(data) {
  return request({
    url: '/ps/csCapitalDetail/frozenBalance',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/accountFunds/csfunddetail.js